import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type DecodedToken ={
  id: number,
  club_id: number,
  trainer_id: number,
  role_id: number,
  exp: number
}

interface AuthState {
  token: string | null;
  trainer_id?: number;
  club_id?: number;
  trainer_name?: string;
  trainer_lastname?: string;
  image_profile?: string;
  setTokenData: (decodedToken: DecodedToken) => void;
  setToken: (token: string) => void;
  setClubId: (id: number) => void;
  setTrainerId: (id: number) => void;
  setNameTrainer: (name: string) => void;
  setLastnameTrainer: (lastname: string) => void;
  setImageProfile: (url: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      setTokenData: (decodedToken: DecodedToken) => set({ trainer_id: decodedToken.trainer_id, club_id: decodedToken.club_id }),
      setTrainerId: (id:number) => set({ trainer_id: id }),
      setToken: (token) => set({ token }),
      setClubId: (id) => set({ club_id: id }),
      setNameTrainer: (name) => set({ trainer_name: name }),
      setLastnameTrainer: (lastname) => set({ trainer_lastname: lastname }),
      setImageProfile: (url) => set({ image_profile : url }),
      logout: () => set({ token: null }),
    }),
    {
      name: 'auth-storage', // key for localStorage
    }
  )
);